import React from "react";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { AppRouter } from "./AppRouter";
import { GlobalStyle } from "./globalStyles";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle />
      <AppRouter />
    </Provider>
  </React.StrictMode>
);
